(() => {
  const money = cents => {
    const value = Number(cents || 0) / 100;

    return value.toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  };

  const normalize = value =>
    String(value || '')
      .normalize('NFKC')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('fr-FR');

  const setCompare = (node, cents) => {
    if (!node) return;

    const amount = Number(cents || 0);

    node.textContent = amount > 0 ? money(amount) : '';
    node.style.display = amount > 0 ? '' : 'none';
  };

  const init = selector => {
    if (!selector || selector.dataset.v3ColorReady === 'true') return;

    selector.dataset.v3ColorReady = 'true';

    const sectionRoot = selector.closest('[id^="vel-v3-"]');

    if (!sectionRoot) return;

    const bundles = Array.from(
      selector.querySelectorAll('[data-v3-bundle]')
    );

    const panels = Array.from(
      selector.querySelectorAll('[data-v3-color-panel]')
    );

    const nativeForms = Array.from(
      sectionRoot.querySelectorAll('[data-v3-native-form]')
    );

    const singleInput = sectionRoot.querySelector(
      '[data-v3-single-form-variant]'
    );

    const duoInput = sectionRoot.querySelector(
      '[data-v3-duo-form-variant]'
    );

    const singlePrice = selector.querySelector(
      '[data-v3-bundle-price="1"]'
    );

    const singleCompare = selector.querySelector(
      '[data-v3-bundle-compare="1"]'
    );

    const duoEachPrice = selector.querySelector(
      '[data-v3-bundle-price="2"]'
    );

    const duoCompare = selector.querySelector(
      '[data-v3-bundle-compare="2"]'
    );

    const duoTotal = selector.querySelector(
      '[data-v3-bundle-total]'
    );

    const singleThumb = selector.querySelector(
      '[data-v3-single-thumb]'
    );

    const duoThumb1 = selector.querySelector(
      '[data-v3-duo-thumb="1"]'
    );

    const duoThumb2 = selector.querySelector(
      '[data-v3-duo-thumb="2"]'
    );

    const singleStatus = selector.querySelector(
      '[data-v3-single-status]'
    );

    const duoStatus = selector.querySelector(
      '[data-v3-duo-status]'
    );

    const singleButtons = Array.from(
      selector.querySelectorAll('[data-v3-single-color]')
    );

    const duoButtons = Array.from(
      selector.querySelectorAll('[data-v3-duo-color]')
    );

    const duoVariants = Array.from(
      selector.querySelectorAll('[data-v3-duo-variant]')
    );

    const bundleByType = type =>
      bundles.find(bundle => bundle.dataset.offerType === type);

    const activeType = () =>
      bundleByType('single')?.classList.contains('is-active')
        ? 'single'
        : 'duo';

    const selectedSingle = () =>
      singleButtons.find(button =>
        button.classList.contains('is-selected')
      ) || singleButtons[0];

    const selectedDuoColor = device =>
      duoButtons.find(
        button =>
          button.dataset.device === String(device) &&
          button.classList.contains('is-selected')
      )?.dataset.color || '';

    const singleImageForColor = color =>
      singleButtons.find(
        button =>
          normalize(button.dataset.color) === normalize(color)
      )?.dataset.image || '';

    const getDuoOption = (variant, position) => {
      return (
        variant.getAttribute(`data-option${position}`) ||
        variant.getAttribute(`data-option-${position}`) ||
        ''
      );
    };

    const setPressed = (buttons, activeButton) => {
      buttons.forEach(button => {
        const selected = button === activeButton;

        button.classList.toggle('is-selected', selected);

        button.setAttribute(
          'aria-pressed',
          selected ? 'true' : 'false'
        );
      });
    };

    const setFormAvailability = (type, available) => {
      nativeForms.forEach(form => {
        const isActive = form.dataset.v3NativeForm === type;

        form.hidden = !isActive;

        const button = form.querySelector('.v3-real-atc');

        if (!button || !isActive) return;

        button.disabled = !available;

        const text = button.querySelector('span');

        if (text) {
          text.textContent = available
            ? 'AJOUTER AU PANIER'
            : 'ÉPUISÉ';
        }
      });
    };

    const updateSingle = () => {
      const button = selectedSingle();

      if (!button) return false;

      const available =
        button.dataset.available === 'true';

      if (singleInput) {
        singleInput.value = button.dataset.variantId || '';
      }

      if (singlePrice) {
        singlePrice.textContent = money(
          button.dataset.price
        );
      }

      setCompare(
        singleCompare,
        button.dataset.compare
      );

      if (singleThumb && button.dataset.image) {
        singleThumb.src = button.dataset.image;
        singleThumb.alt =
          button.dataset.color || 'Velouré';
      }

      const bundle = bundleByType('single');

      if (bundle) {
        bundle.dataset.selectedAvailable =
          String(available);
      }

      if (singleStatus) {
        singleStatus.textContent = available
          ? ''
          : 'Cette couleur est momentanément épuisée.';

        singleStatus.classList.toggle(
          'is-error',
          !available
        );
      }

      return available;
    };

    const findDuoVariant = () => {
      const first = normalize(selectedDuoColor(1));
      const second = normalize(selectedDuoColor(2));

      return (
        duoVariants.find(variant => {
          const option1 = normalize(
            getDuoOption(variant, 1)
          );

          const option2 = normalize(
            getDuoOption(variant, 2)
          );

          return (
            option1 === first &&
            option2 === second
          );
        }) || null
      );
    };

    const updateDuo = () => {
      const first = selectedDuoColor(1);
      const second = selectedDuoColor(2);

      const variant = findDuoVariant();

      const image1 = singleImageForColor(first);
      const image2 = singleImageForColor(second);

      if (duoThumb1 && image1) {
        duoThumb1.src = image1;
        duoThumb1.alt = first;
      }

      if (duoThumb2 && image2) {
        duoThumb2.src = image2;
        duoThumb2.alt = second;
      }

      const available =
        Boolean(variant) &&
        variant.dataset.available === 'true';

      if (duoInput) {
        duoInput.value =
          variant?.dataset.variantId || '';
      }

      if (variant) {
        const total = Number(
          variant.dataset.price || 0
        );

        if (duoEachPrice) {
          duoEachPrice.textContent =
            money(total / 2);
        }

        if (duoTotal) {
          duoTotal.textContent =
            money(total);
        }

        setCompare(
          duoCompare,
          variant.dataset.compare
        );
      }

      const bundle = bundleByType('duo');

      if (bundle) {
        bundle.dataset.selectedAvailable =
          String(available);
      }

      if (duoStatus) {
        if (!variant) {
          duoStatus.textContent =
            'Cette combinaison n’est pas disponible.';
        } else if (!available) {
          duoStatus.textContent =
            'Cette combinaison est momentanément épuisée.';
        } else {
          duoStatus.textContent = '';
        }

        duoStatus.classList.toggle(
          'is-error',
          !available
        );
      }

      return available;
    };

    const activate = type => {
      bundles.forEach(bundle => {
        const active =
          bundle.dataset.offerType === type;

        bundle.classList.toggle(
          'is-active',
          active
        );

        const radio = bundle.querySelector(
          'input[type="radio"]'
        );

        if (radio) {
          radio.checked = active;
        }
      });

      panels.forEach(panel => {
        const active =
          panel.dataset.v3ColorPanel === type;

        panel.hidden = !active;

        panel.classList.toggle(
          'is-open',
          active
        );
      });

      const available =
        type === 'single'
          ? updateSingle()
          : updateDuo();

      setFormAvailability(
        type,
        available
      );
    };

    bundles.forEach(bundle => {
      bundle.addEventListener('click', () => {
        activate(
          bundle.dataset.offerType || 'single'
        );
      });
    });

    singleButtons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();

        setPressed(
          singleButtons,
          button
        );

        const available = updateSingle();

        if (activeType() === 'single') {
          setFormAvailability(
            'single',
            available
          );
        }
      });
    });

    duoButtons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();

        const sameDevice = duoButtons.filter(
          item =>
            item.dataset.device ===
            button.dataset.device
        );

        setPressed(
          sameDevice,
          button
        );

        const available = updateDuo();

        if (activeType() === 'duo') {
          setFormAvailability(
            'duo',
            available
          );
        }
      });
    });

    updateSingle();
    updateDuo();

    activate(
      bundleByType('duo')?.classList.contains(
        'is-active'
      )
        ? 'duo'
        : 'single'
    );
  };

  const initAll = root => {
    (root || document)
      .querySelectorAll?.(
        '[data-v3-offer-colors]'
      )
      .forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(document)
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    event => initAll(event.target)
  );
})();